/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-03T17:01:48-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';

const style = StyleSheet.create({
  avatar: {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 'normal'
  },

  avatar_img: {
    display: 'inline-block',
    verticalAlign: 'middle',
    borderRadius: '100%',
    width: '100%',
    height: '100%'
  }
});

const Avatar = (props) => {

  return (
    <div className={css(style.avatar)}>
      <img className={css(style.avatar_img)} src={props.src} alt={props.alt || 'profile'} />
    </div>
  )
}



export default Avatar;



// WEBPACK FOOTER //
// ./src/components/common/Avatar.jsx